'use client';

import { useProductList } from 'components/gruenland/organisms/product-list/context';
import ProductList, { ProductListProps } from 'components/gruenland/organisms/product-list/ProductList';

const ProductListWrapped = ({ products }: ProductListProps) => {
  const { additionalItems } = useProductList();

  return <ProductList products={[...products, ...additionalItems]} />;
};

export default ProductListWrapped;
